import { USAGE_STATEMENT_STATUS_FULL } from '@/modules/copay/entities/enums/usageStatement';
import { UsageStatementProcess } from '@/modules/copay/entities/interfaces/usageStatements';

export const TRANSLATED_USAGE_STATEMENT_PROCESS_STATUS: Partial<
  Record<USAGE_STATEMENT_STATUS_FULL, string>
> = Object.freeze({
  [USAGE_STATEMENT_STATUS_FULL.NOT_PROCESSED]: 'Aguardando confirmação',
  [USAGE_STATEMENT_STATUS_FULL.WAITING_DESCRIPTION]: 'Pendente',
  [USAGE_STATEMENT_STATUS_FULL.WAITING_LABELING]: 'Análise time de saúde',
  [USAGE_STATEMENT_STATUS_FULL.PROCESSED]: 'Processado',
  [USAGE_STATEMENT_STATUS_FULL.FINISHED]: 'Finalizado',
  [USAGE_STATEMENT_STATUS_FULL.ERROR]: 'Erro',
  [USAGE_STATEMENT_STATUS_FULL.REFUSED]: 'Arquivo recusado',
});

export const initialStateUsageStatementProcess: UsageStatementProcess = {
  id: '',
  usageStatementId: '',
  fileName: '',
  competenceMonth: 1,
  competenceYear: 2023,
  status: USAGE_STATEMENT_STATUS_FULL.NOT_PROCESSED,
  approveAt: '',
  approveBy: '',
  descriptionAddedAt: '',
  descriptionAddedBy: '',
  labelAddedAt: '',
  labelAddedBy: '',
  sharedAt: '',
  sharedBy: '',
  createdAt: '',
  createdBy: '',
  resultFileLink: '',
  resultFileId: '',
  originalFileId: '',
  contractCode: '',
  deletedAt: '',
  errorMessage: '',
  companyGroupId: '',
};
